import StatusPage from "./StatusPage";
import { Button, type ButtonProps } from "@clarityos/ui/button";
import { twMerge } from "tailwind-merge";

interface Props {
  title?: string;
  description?: string;
  actionButton?: ButtonProps;
}

const ErrorPage = ({ title, description, actionButton }: Props) => {
  return (
    <StatusPage
      icon={"/error-page.svg"}
      title={title ?? "We’re having trouble"}
      description={
        description ??
        "Looks like something isn’t working as expected. Please notify the practice."
      }
      footer={
        actionButton && (
          <Button
            size="md"
            variant="primary"
            {...actionButton}
            className={twMerge(
              "mx-auto w-full max-w-[260px]",
              actionButton.className,
            )}
          >
            {actionButton.children ?? "Try Again"}
          </Button>
        )
      }
    />
  );
};

export default ErrorPage;
